import { Menu } from '~/modules/elements/akui/menu';

export const MenuButton = Menu.Button;
export const MenuContainer = Menu;
